import utils from '../utils';

export default {
  gallery: {
    wixInit: false,
    renderedItemsCount: 50,
    videoIndexPlay: -1,
    documentHeight: utils.getScreenHeight()
  },
  fullscreen: {
  },
  multishare: {
  }
};



// WEBPACK FOOTER //
// ./reducers/initialState.js